export const COMPETITORS = [
  { slug: "chatpdf", name: "ChatPDF" },
  { slug: "askyourpdf", name: "AskYourPDF" },
  { slug: "humata", name: "Humata AI" },
  { slug: "pdfai", name: "PDF.ai" },
  { slug: "hipdf", name: "HiPDF" },
];
